var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "content-header",
      class: {
        "bg-type": _vm.bgType,
        "bg-height": _vm.bgHeight,
        "no-radius": _vm.noRadius,
        "mbtm-16": _vm.mbtm16,
        "mbtm-20": _vm.mbtm20,
        "mbtm-24": _vm.mbtm24,
        "mbtm-54": _vm.mbtm54
      }
    },
    [
      _vm.title
        ? _c("div", { staticClass: "title" }, [
            _c("h2", { domProps: { innerHTML: _vm._s(_vm.$t(_vm.title)) } })
          ])
        : _vm._e(),
      _vm.description
        ? _c("div", {
            staticClass: "description",
            domProps: { innerHTML: _vm._s(_vm.$t(_vm.description)) }
          })
        : _vm._e(),
      _vm._m(0),
      _vm.tabs ? _c("div", [_vm._t("tab")], 2) : _vm._e(),
      _vm.subtitle
        ? _c("div", { staticClass: "title" }, [
            _c("h5", { domProps: { innerHTML: _vm._s(_vm.$t(_vm.subtitle)) } })
          ])
        : _vm._e(),
      _vm.description3
        ? _c("div", {
            staticClass: "description3",
            domProps: { innerHTML: _vm._s(_vm.$t(_vm.description3)) }
          })
        : _vm._e(),
      _vm._t("card")
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-img" }, [
      _c("i", { staticClass: "icon icon-img-deposit-complete2" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }